import { ROUTE_METADATA } from 'app/AppRoutes/RouteMetadata'
import ProtectedRoute from '../ProtectedRoute'
import useBoundStore from 'domains/zustand/store'

const ProtectedByLogin = () => {
  const user = useBoundStore((state) => state.user)

  const isAllowed = !!user

  if (!isAllowed) {
    const { pathname, search } = window.location
    const referrerPath = `${pathname}${search}`
    sessionStorage.setItem('referrer', referrerPath)
  }

  return (
    <ProtectedRoute
      isAllowed={isAllowed}
      redirectPath={ROUTE_METADATA.signin.path}
    />
  )
}

ProtectedByLogin.propTypes = {}

ProtectedByLogin.defaultProps = {}

export default ProtectedByLogin
